import React from "react";

import { assetService } from "services/asset-management/AssetService";

export const useParentAssetId = (parentUuid?: string): string => {
    const [parentAssetId, setParentAssetId] = React.useState<string>("");

    React.useEffect(() => {
        if (!parentUuid) {
            setParentAssetId("");
            return;
        }

        const abortController = new AbortController();
        assetService
            .fetchAssetByUuid(parentUuid, abortController)
            .then((parentAsset) => {
                setParentAssetId(parentAsset.assetId ?? "");
            })
            .catch(() => {
                setParentAssetId("");
            });

        return () => abortController.abort();
    }, [parentUuid]);

    return parentAssetId;
};
